import {
  Card,
  Typography,
  Box,
  List,
  ListItem,
  Button,
  Tab,
  IconButton,
  Divider,
  Chip,
} from "@mui/material";
import { ToastContainer, toast, Zoom } from "react-toastify";
import { useEffect, useState } from "react";
import {
  getSubscriptionPageVisitedCustomerData,
  deleteViewedContactDetails,
} from "../../../api/api";
import { loadAnimation } from "lottie-web";
import { defineElement } from "lord-icon-element";
import "./style.css";
import Loading from "../../../ui-components/Loding/Loading";
import FilterListIcon from "@mui/icons-material/FilterList";
import "../../Users/Profile/style.scss";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import UserList from "./UserList";
import RecentSubscriptionVisitUser from "./RecentSubscriptionVisitUser";
import MatchedUser from "./MatchedUser";

// register lottie and define custom element
defineElement(loadAnimation);

const userList = [
  {
    name: "Aasha",
    description: "Software Engineer",
    dob: "1990-01-01",
    mobile: "+91 9876******",
    matched: "Religion, Location, Skills",
    horoscope: "Aries",
    age: 26,
  },
  {
    name: "Karthika",
    description: "Data Scientist",
    dob: "1990-01-01",
    mobile: "+91 9876******",
    matched: "Location, Horoscope",
    horoscope: "Taurus",
    age: 27,
  },
  {
    name: "Kavya",
    description: "DevOps Engineer",
    dob: "1990-01-01",
    mobile: "+91 9876******",
    matched: "Cast, Job",
    horoscope: "Gemini",
    age: 28,
  },
  {
    name: "Kodeswari",
    description: "HR Manager",
    dob: "1990-01-01",
    mobile: "+91 9876******",
    horoscope: "Cancer",
    age: 20,
  },
  {
    name: "Lavanya",
    description: "Project Manager",
    dob: "1990-01-01",
    mobile: "+91 9876******",
    horoscope: "Leo",
    age: 29,
  },
  {
    name: "Nainika",
    description: "UX Designer",
    dob: "1990-01-01",
    mobile: "+91 9876******",
    horoscope: "Virgo",
    age: 23,
  },
  {
    name: "Sita",
    description: "Teacher",
    dob: "1990-01-01",
    mobile: "+91 9876******",
    horoscope: "Libra",
    age: 29,
  },
  {
    name: "Pooja",
    description: "Accountant",
    dob: "1990-01-01",
    mobile: "+91 9876******",
    horoscope: "Scorpio",
    age: 23,
  },
  {
    name: "Poornima",
    description: "Marketing Executive",
    dob: "1990-01-01",
    mobile: "+91 9876******",
    horoscope: "Sagittarius",
    age: 23,
  },
];

const CustomerDetails = () => {
  const [customerData, setCustomerData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    getProfile();
  }, []);

  const getProfile = async () => {
    try {
      const response = await getSubscriptionPageVisitedCustomerData();
      if (response) {
        setCustomerData([...response.data]);
        setLoading(false);
      }
    } catch (error) {
      toast.error(
        error?.message
          ? error.message
          : error?.response?.data?.error?.message || "Something went wrong",
        {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
          transition: Zoom,
        }
      );
      setLoading(false);
    }
  };
  const deleteContact = async (customerDataEle) => {
    try {
      setLoading(true);
      const response = await deleteViewedContactDetails(customerDataEle.id);
      if (response) {
        getProfile();
      }
    } catch (error) {
      toast.error(
        error?.message
          ? error.message
          : error?.response?.data?.error?.message || "Something went wrong",
        {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
          transition: Zoom,
        }
      );
      setLoading(false);
    }
  };
  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box>
      <TabContext value={tabValue}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems={"center"}
          sx={{
            borderBottom: 1,
            borderColor: "divider",
          }}
        >
          <TabList onChange={handleChangeTab} aria-label="lab API tabs example">
            <Tab label="Users List" value={0} wrapped />
            <Tab label="Recent Subscription Visit" value={1} wrapped />
            <Tab label="Matched User" value={2} wrapped />
          </TabList>{" "}
          <Button
            variant="outlined"
            startIcon={<FilterListIcon />}
            onClick={() => console.log("Filter Clicked")}
            sx={{
              height: 30,
            }}
          >
            Filter
          </Button>
        </Box>
        <TabPanel value={0}>
          <UserList
            users={userList}
            onUserClick={() => console.log("user click")}
          />
        </TabPanel>
        <TabPanel value={1}>
          {" "}
          <RecentSubscriptionVisitUser
            recentData={userList}
            onClickRecentData={() => console.log("user click")}
          />
        </TabPanel>
        <TabPanel value={2}>
          <MatchedUser
            user={userList}
            // onClickRecentData={() => console.log("user click")}
          />
        </TabPanel>
      </TabContext>
    </Box>
    // <div className="container-fluid profile">
    //   <h2>Subscription Page Visited Customer Details</h2>
    //   <div>
    //     <div>
    //       <Box>
    //         <Loading loading={loading} />

    //         <div className="row">
    //           <div className="col-12">
    //             <List>
    //               {customerData &&
    //                 customerData.map((customerDataEle) => {
    //                   return (
    //                     <ListItem className="row">
    //                       <Card
    //                         sx={{ minWidth: 275 }}
    //                         variant="outlined"
    //                         className="grid-container"
    //                       >
    //                         <div class="grid-item">
    //                           <Typography
    //                             variant="h6"
    //                             color="text.secondary"
    //                             component="div"
    //                           >
    //                             {customerDataEle.name}
    //                           </Typography>
    //                         </div>

    //                         <div class="grid-item">
    //                           <Typography
    //                             variant="h6"
    //                             color="text.secondary"
    //                             component="div"
    //                           >
    //                             {customerDataEle.mobileno}
    //                           </Typography>
    //                         </div>
    //                         <Button
    //                           className="button"
    //                           type="submit"
    //                           variant="contained"
    //                           color="primary"
    //                           // disabled={checkEmailValid()}
    //                           onClick={() => deleteContact(customerDataEle)}
    //                         >
    //                           Delete
    //                         </Button>
    //                       </Card>
    //                     </ListItem>
    //                   );
    //                 })}
    //             </List>
    //           </div>
    //         </div>
    //       </Box>
    //     </div>
    //   </div>
    //   <ToastContainer />
    // </div>
  );
};

export default CustomerDetails;
